import { render, staticRenderFns } from "./BitQCorsi.vue?vue&type=template&id=21bfa6aa&scoped=true"
import script from "./BitQCorsi.vue?vue&type=script&lang=js"
export * from "./BitQCorsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfa6aa",
  null
  
)

export default component.exports